export const ja = {
  heroData: {
    title: "機内への持ち込み制限のある手荷物",
    subtitle: "安全で快適なフライトのため、機内への持ち込みについてのガイドラインをご確認ください。",
    image: "https://readdy.ai/api/search-image?query=Luxury%20helicopter%20cabin%20interior%20with%20leather%20seats%20and%20panoramic%20window%2C%20clean%20minimal%20interior%20design%2C%20soft%20warm%20lighting%2C%20dark%20navy%20sky%20outside%2C%20aviation%20safety%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=1920&height=600&seq=baghero01&orientation=landscape",
  },
  allowedData: {
    label: "ALLOWED",
    title: "持ち込み可能なもの",
    items: [
      { name: "スマートフォン", desc: "撮影・SNS投稿OK（ただし、機内では手ぶれに注意）" },
      { name: "カメラ", desc: "小型のカメラは持ち込み可能です" },
      { name: "財布・小物", desc: "ポケットに入る程度の小物は問題ありません" },
      { name: "サングラス", desc: "昼間コースでおすすめです" },
      { name: "上着・羽織", desc: "機内やヘリポートで羽織れるものをおすすめします" },
      { name: "お薬", desc: "必要なお薬はお持ちください" },
    ],
  },
  prohibitedData: {
    label: "PROHIBITED",
    title: "持ち込みできないもの",
    items: [
      { name: "三脚・自撮り棒", desc: "機内での使用は危険なため禁止です" },
      { name: "バッグ・リュック", desc: "機内には持ち込めません。受付で預かります" },
      { name: "飲食物", desc: "機内での飲食は禁止です（ドリンクサービスは運航会社が提供）" },
      { name: "危険物・可燃物", desc: "ライター、マッチ、スプレー缶などは禁止です" },
      { name: "傘（長いもの）", desc: "折りたたみ傘はOKですが、長傘は機内に持ち込めません" },
      { name: "ペット", desc: "ペットの搭乗は承っておりません" },
    ],
  },
  tipsData: {
    label: "TIPS",
    title: "持ち物のヒント",
    items: [
      "貴重品は必ず身につけてください。預かり物は自己責任となります",
      "スマートフォンのストラップを使用すると、落下防止になります",
      "帽子は風で飛ばされる可能性があるため、おすすめしません",
      "ヘリポートは屋外のため、季節に応じた服装・持ち物をおすすめします",
      "機内は比較的静かですが、騒音対策としてイヤーマフの持参も可能です",
    ],
  },
};

export const en = {
  heroData: {
    title: "Cabin Baggage Restrictions",
    subtitle: "Please review our baggage guidelines to ensure a safe and comfortable flight.",
    image: "https://readdy.ai/api/search-image?query=Luxury%20helicopter%20cabin%20interior%20with%20leather%20seats%20and%20panoramic%20window%2C%20clean%20minimal%20interior%20design%2C%20soft%20warm%20lighting%2C%20dark%20navy%20sky%20outside%2C%20aviation%20safety%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=1920&height=600&seq=baghero01&orientation=landscape",
  },
  allowedData: {
    label: "ALLOWED",
    title: "What You Can Bring",
    items: [
      { name: "Smartphone", desc: "Photos and social media posts are welcome (watch for vibration inside the cabin)" },
      { name: "Camera", desc: "Small cameras are permitted" },
      { name: "Wallet & small items", desc: "Pocket-sized items are fine" },
      { name: "Sunglasses", desc: "Recommended for daytime tours" },
      { name: "Jacket or cardigan", desc: "Something you can layer at the helipad or in the cabin" },
      { name: "Medication", desc: "Please bring any medication you require" },
    ],
  },
  prohibitedData: {
    label: "PROHIBITED",
    title: "What You Cannot Bring",
    items: [
      { name: "Tripods & selfie sticks", desc: "Prohibited inside the cabin due to safety risks" },
      { name: "Bags & backpacks", desc: "Not permitted in the cabin — will be held at check-in" },
      { name: "Food & beverages", desc: "Eating and drinking in the cabin is not allowed (drinks provided by the operator)" },
      { name: "Hazardous & flammable items", desc: "Lighters, matches, and spray cans are prohibited" },
      { name: "Umbrellas (full-size)", desc: "Compact folding umbrellas are OK; full-size umbrellas are not permitted" },
      { name: "Pets", desc: "We are unable to accommodate pets" },
    ],
  },
  tipsData: {
    label: "TIPS",
    title: "Baggage Tips",
    items: [
      "Keep valuables on your person at all times. You are responsible for any items left in storage.",
      "Using a wrist strap for your smartphone helps prevent accidental drops.",
      "Hats are not recommended as they may be blown off by the wind.",
      "The helipad is outdoors — please dress and pack appropriately for the season.",
      "The cabin is relatively quiet, but you may bring ear protection if you prefer.",
    ],
  },
};
